module.exports = __webpack_public_path__ + "static/media/learner_blogpost.2516e1bf.png";